<template>
  <div class="home">
    <web-heard></web-heard>
    <router-view />
    <callus-form style="margin-top:100px;" id="callusForm"></callus-form>
  </div>
</template>

<script>
// @ is an alias to /src
import WebHeard from "../components/WebHeard.vue";
import callusForm from "../components/callusForm.vue";
export default {
  name: "home",
  components: {
    WebHeard,
    callusForm
  }
};
</script>
